import { getUserPlatform } from 'modules/employees/add-edit-employee-modal/helpers';
import Employees from 'modules/employees/Employees';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';

const EmployeesRouteWrapper = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const platform = getUserPlatform();
  const isMobile = platform === 'Android' || platform === 'iOS';

  if (searchParams.has('skipMobile') || !isMobile) {
    return <Employees />;
  }

  return <Navigate to="/employees-app" state={{ from: location.pathname }} />;
};

export default EmployeesRouteWrapper;
